import { z } from 'zod'

export const AuthenticationTokenSchema = z
  .object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expireTime: z.number().optional(),
    expiresIn: z.number().optional(),
    tokenType: z.string().optional(),
  })
  .transform((value) => ({
    accessToken: value.accessToken,
    refreshToken: value.refreshToken,
    expireTime: value.expireTime ?? value.expiresIn ?? 0,
    tokenType: value.tokenType,
  }))
export type AuthenticationToken = z.infer<typeof AuthenticationTokenSchema>

export const CaptchaSchema = z.object({
  captchaId: z.string().min(1),
  captchaBase64: z.string().min(1),
})
export type Captcha = z.infer<typeof CaptchaSchema>

export interface LoginForm {
  username: string
  password: string
  captchaId: string
  captchaCode: string
}
